// Title click
$(document).on("click", ".shop-analyse-title", function () {
  let parent = $(this).closest(".shop-analyse-accordion");
  let content = parent.find(".shop-analyse-content");
  let arrow = parent.find(".accordion-arrow");

  parent.toggleClass("active"); // add/remove immediately
  content.stop(true, true).slideToggle(300);
  arrow.toggleClass("rotate");
});

// Arrow click
$(document).on("click", ".accordion-arrow", function () {
  let parent = $(this).closest(".shop-analyse-accordion");
  let content = parent.find(".shop-analyse-content");

  parent.toggleClass("active"); // add/remove immediately
  content.stop(true, true).slideToggle(300);
  $(this).toggleClass("rotate");
});

// Ignore switch clicks
$(document).on("click", ".shop-analyse-switch", function (e) {
  e.stopPropagation();
});


$(document).on("change", ".shop-analyse-switch", function () {
  let $checkbox = $(this);
  let variantId = $checkbox.attr("var-id");

  // Disable to prevent spam clicks
  $checkbox.prop("disabled", true);

  if ($checkbox.is(":checked")) {
    // Add to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      }),
    })
      .then((res) => res.json())
      .then(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
      })
      .finally(() => {
        // Enable again after cart refresh
        setTimeout(() => {
          $checkbox.prop("disabled", false);
        }, 1000);
      });
  } else {
    // Remove all quantities of this variant
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        let lineItems = cart.items.filter(item => item.variant_id == variantId);

        if (lineItems.length > 0) {
          // Promise chain: remove all items for this variant
          let promises = lineItems.map(item =>
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              }),
            })
          );

          return Promise.all(promises);
        }
      })
      .then(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
      })
      .finally(() => {
        setTimeout(() => {
          $checkbox.prop("disabled", false);
        }, 1000);
      });
  }
});






